var map = {
	"./01.jpg": 299,
	"./02.jpg": 300,
	"./03.JPG": 301,
	"./04.jpg": 302,
	"./05.jpg": 303,
	"./125327233_10222831927082161_6440974222704808100_n.jpg": 304,
	"./Artie 4.jpg": 305,
	"./IMG_5285.JPG": 306,
	"./Jai Jemmi.JPG": 307,
	"./ShuiabMoosa 12.95kg 7th.jpg": 308,
	"./WhatsApp Image 2022-10-18 at 10.55.35 AM.jpeg": 309,
	"./WhatsApp Image 2022-10-18 at 11.39.04 AM.jpeg": 310,
	"./WhatsApp Image 2022-10-18 at 11.40.47 AM.jpeg": 311,
	"./WhatsApp Image 2022-10-18 at 9.38.44 AM.jpeg": 312,
	"./WhatsApp Image 2025-10-08 at 13.01.57_b2dbc33c.jpg": 313,
	"./kfc-24-4.jpg": 314,
	"./kfc-24-5.jpg": 315,
	"./kfc-24-9.jpg": 316
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 298;